/**
 * round visual with checkmark for checkbox/radio-box
 */

import React, { useState } from 'react';
import styles from './Check.scss';

export interface ICheckProps {
    checked: boolean;
}

const Check: React.FC<React.PropsWithChildren<ICheckProps>> = ({ checked = false }) => {
    return (
        <div className={styles.check + (checked ? ' ' + styles.active : '')}>
            <input type="checkbox" />
            <svg viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
            </svg>
        </div>
    );
};

export default Check;
